import type { RegionConfig, SurfBreak, Camera } from "./regions";
import type { Zone } from "./zones";

export function getCamerasFromRegion(region: RegionConfig): Camera[] {
  return region.breaks
    .map((b) => {
      const primary = b.cameras[0];
      return {
        id: b.id,
        name: b.name,
        url: primary?.url ?? "",
        kind: primary?.kind ?? "stream",
        source: primary?.source,
      };
    })
    .sort((a, b) => a.name.localeCompare(b.name));
}

/** Check if a region has any breaks with actual camera streams */
export function regionHasCameras(region: RegionConfig): boolean {
  return region.breaks.some((b) => b.cameras.length > 0);
}

export function getBreakFromRegion(
  region: RegionConfig,
  breakId: string,
): SurfBreak | undefined {
  return region.breaks.find((b) => b.id === breakId);
}

export function findRegionInZones(
  zones: Zone[],
  regionId: string,
): {
  zone: Zone;
  country: {
    id: string;
    label: string;
    regions: { id: string; label: string }[];
  };
  region: { id: string; label: string };
} | null {
  for (const zone of zones) {
    for (const country of zone.countries) {
      for (const region of country.regions) {
        if (region.id === regionId) {
          return { zone, country, region };
        }
      }
    }
  }
  return null;
}
